// extracted by mini-css-extract-plugin
export var container = "CartOverlay_container__LC4hp";